module.exports = "/src/views/player/documets/fibbadge/images/fib_logo.png";